import React from 'react';
import { Spin } from 'antd';

import { Container } from './styles';

const Spinner: React.FC = () => {
  return (
    <Container>
      <Spin size="large" />
    </Container>
  );
};

export default Spinner;
